export default __webpack_public_path__ + "static/media/temp.32492d47.png";